<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 6 -->
  <div class="rappider-container container-6 col-12">
    <!-- Container: Container 1 -->
    <div class="rappider-container container-1 col-2 menu-with-bg">
      <!-- Container: Container 2 -->
      <div class="rappider-container container-2 col-12">
        <div class="rappider-component image-4 radius-logo">
          <!-- Component: Image 4 -->
          <rappider-image
            [source]="image_4.source"
            [alternateText]="image_4.alternateText"
            [placeholder]="image_4.placeholder"
            [disablePreview]="image_4.disablePreview"
            [borderSettings]="image_4.borderSettings"
            [shadowSettings]="image_4.shadowSettings"
            [paddingSettings]="image_4.paddingSettings"
            [marginSettings]="image_4.marginSettings"
            [customSizeSettings]="image_4.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>

      <!-- Container: Container 5 -->
      <div class="rappider-container container-5 col-12">
        <div class="rappider-component menu-6">
          <!-- Component: Menu 6 -->
          <rappider-menu
            [config]="menu_6.config"
            [isCollapsed]="menu_6.isCollapsed"
            [paddingValue]="menu_6.paddingValue"
            [menuPlacement]="menu_6.menuPlacement"
            [isDisabled]="menu_6.isDisabled"
            [showLabels]="menu_6.showLabels"
            [activeItem]="menu_6.activeItem"
            [currentSubmenuOnly]="menu_6.currentSubmenuOnly"
            (menuItemClick)="menu_6_menuItemClick($event)"
          >
          </rappider-menu>
        </div>
      </div>
    </div>

    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-10 layout-padding">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
